import { DUR } from '@/animations/settings/vars'
import { cn } from '@/lib/utils'
import { Typo3Image, Typo3Section } from '@/types/typo3'
import {
  ButtonSocial,
  Container,
  CopyButton,
  Div,
  Img,
  Richtext,
  Section,
  Time,
  Title
} from '@/ui/components'
import { memo } from 'react'

// TODO: Finish social links functions

interface SectionHeroNewsProps {
  date?: string
  title: string
  leadText?: string
  image?: Typo3Image
  section?: Typo3Section
}

const SectionHeroNews = ({
  date,
  title,
  leadText,
  image,
  section
}: SectionHeroNewsProps) => (
  <Section data={section} className={cn('s-section-hero-news pt-5xl pb-xl')}>
    <Container size="sm-fixed">
      <Div
        className={cn('')}
        anim="fade-in"
        animVars={{ delay: DUR.stagger * 2 }}
      >
        <Time date={date} className="mb-xl" />
        <Title as="h1" className="h2 mb-md">
          {title}
        </Title>
      </Div>
      {leadText && (
        <Div anim="fade-in" animVars={{ delay: DUR.stagger * 3 }}>
          <Richtext className="h5" text={leadText} />
        </Div>
      )}

      <ButtonSocial.Wrapper
        anim="fade-in"
        animVars={{ delay: DUR.stagger * 3.5 }}
      >
        <ButtonSocial.Item icon="facebook" href="https://www.google.com" />
        <ButtonSocial.Item icon="threads" href="https://www.google.com" />
        <ButtonSocial.Item icon="linkedin" href="https://www.google.com" />
        <CopyButton className="relative size-9 rounded-full border border-neutral-600" />
      </ButtonSocial.Wrapper>
    </Container>
    {image && (
      <Container
        anim="fade-in"
        className="mt-2xl"
        size="md-fixed"
        animVars={{ delay: DUR.stagger * 4 }}
      >
        <Img
          data={image}
          crop={{ width: 1000, height: 1000 }}
          className="w-full"
        />
      </Container>
    )}
  </Section>
)

SectionHeroNews.displayName = 'SectionHeroNews'

export default memo(SectionHeroNews)
